export interface IntegrationLog
{
    CompanyID: number;
    FrequencyID: number;
    RowID: number;
    ApiEndpoint: string;
    ConsecutiveFailures: number;
    LastAttempt: Date;
    LastRunDate: Date;
    LastRecordsReturned: number;
    RunStartTime: Date;
    RunEndTime: Date;
    Successful: boolean;
    Warnings: string[];
}

export interface SelectedFilters {
    StartDate: Date;
    EndDate: Date;
    Result: number[];
}

export enum Result {
    All = 0, 
    Failure = 1,
    Success = 2,
}
